module.exports = __webpack_public_path__ + "static/media/09.a873a804.jpg";